module.exports = __webpack_public_path__ + "img/kapla-grey.d96bf0ea.png";